<!-- widget Control configuration -->
<!-- <div *ngIf="expansionStyle == 'body'">
    <div class="c-title--subsection" >Advisor Widget Label</div>
    <div class="row">
        <div class="col-sm-6" *ngFor="let configKey of objectKeys(widgetTextConfiguration)">
            <div class="c-form-group">
                <div class="c-form-group__label"><label [for]="configKey">{{ formatConfigurationKeyDisplay(configKey) }}</label></div>
                <input class="c-form-group__input" [(ngModel)]="widgetTextConfiguration[configKey]" [id]="configKey" name="{{ configKey }}" cclFormInput/>
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
    </div>
</div> -->

<div *ngIf="expansionStyle == 'body'">

    <div class="config__bottom_border">
        <div class="auto-flex">
            <div class="leftDiv">
                <div class="c-title--subsection">Populate Catalog Configuration</div>
            </div>
            <div class="rightDiv">
                <ccl-toggle-button
                    [title]="sessionWidgetConfig.widget.applyCatalogConfiguration ? 'Enable' : 'Disable'"
                    [isChecked]="sessionWidgetConfig.widget.applyCatalogConfiguration"
                    (isCheckedChange)="toggleApplyCatalogConfiguration($event)">
                    {{ sessionWidgetConfig.widget.applyCatalogConfiguration ? "Enabled" : "Disabled" }}
                </ccl-toggle-button>
            </div>
            
            <div class="rightDiv margin-rt5" title="Reset Default Configuration" *ngIf="sessionWidgetConfig.widget.applyCatalogConfiguration">
                <button class="c-btn c-btn--primary reset-config-btn" (cclClick)="resetLabelConfiguration()">
                    <i class="fa fa-refresh" [ngClass]="{'fa-spin' : resetLoading}"></i>
                </button>
            </div>		
            <div style="clear:both"></div>
        </div>
    </div>

    <div class="ptop10">
    <!-- General Labels section -->
    <div class="c-title--subsection config__bottom_border mb5-rem"><label>General Labels</label></div>
    <div class="row">
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="widgetTitle">Title</label></div>
                <input class="c-form-group__input" 
                    [ngClass]="{'disabled-div':!sessionWidgetConfig.widget.applyCatalogConfiguration}"
                    [(ngModel)]="widgetTextConfiguration.title" cclFormInput/>
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>

        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="addToSchedule">Add to Schedule</label></div>
                <input class="c-form-group__input" 
                    [ngClass]="{'disabled-div':!sessionWidgetConfig.widget.applyCatalogConfiguration}"
                    [(ngModel)]="widgetTextConfiguration.addToSchedule" cclFormInput/>
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>

        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="replaceSchedule">Replace Schedule</label></div>
                <input class="c-form-group__input" 
                    [ngClass]="{'disabled-div':!sessionWidgetConfig.widget.applyCatalogConfiguration}"
                    [(ngModel)]="widgetTextConfiguration.replaceSchedule" cclFormInput/>
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>

        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="overlapSchedule">Overlap Schedule</label></div>
                <input class="c-form-group__input" 
                    [ngClass]="{'disabled-div':!sessionWidgetConfig.widget.applyCatalogConfiguration}"
                    [(ngModel)]="widgetTextConfiguration.overlapSchedule" cclFormInput/>
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>

        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="waitlistSchedule">Join Waitlist</label></div>
                <input class="c-form-group__input" 
                    [ngClass]="{'disabled-div':!sessionWidgetConfig.widget.applyCatalogConfiguration}"
                    [(ngModel)]="widgetTextConfiguration.waitlistSchedule" cclFormInput/>
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>

        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="confirmButton">Confirm Button</label></div>
                <input class="c-form-group__input" 
                    [ngClass]="{'disabled-div':!sessionWidgetConfig.widget.applyCatalogConfiguration}"
                    [(ngModel)]="widgetTextConfiguration.confirmButton" cclFormInput/>
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>

        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="cancelButton">Cancel Button</label></div>
                <input class="c-form-group__input" 
                    [ngClass]="{'disabled-div':!sessionWidgetConfig.widget.applyCatalogConfiguration}"
                    [(ngModel)]="widgetTextConfiguration.cancelButton" cclFormInput/>
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
    </div>

    <!-- Notifications & Reviews section -->
    <div class="c-title--subsection config__bottom_border mb5-rem"><label>Notifications & Review</label></div>
    <div class="row">
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="recommendationsToReview">Recommendations to Review</label></div>
                <input class="c-form-group__input" 
                    [ngClass]="{'disabled-div':!sessionWidgetConfig.widget.applyCatalogConfiguration}"
                    [(ngModel)]="widgetTextConfiguration.recommendationsToReview" cclFormInput/>
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>

        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="recommendationsToReviewClick">Click to Review</label></div>
                <input class="c-form-group__input" 
                    [ngClass]="{'disabled-div':!sessionWidgetConfig.widget.applyCatalogConfiguration}"
                    [(ngModel)]="widgetTextConfiguration.recommendationsToReviewClick" cclFormInput/>
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
    </div>

    <!-- Session & Search section -->
    <div class="c-title--subsection config__bottom_border mb5-rem"><label>Session & Search</label></div>
    <div class="row">
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="recommendationDetails">Session Details</label></div>
                <input class="c-form-group__input" 
                    [ngClass]="{'disabled-div':!sessionWidgetConfig.widget.applyCatalogConfiguration}"
                    [(ngModel)]="widgetTextConfiguration.recommendationDetails" cclFormInput/>
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>

        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="similarSessions">Similar Sessions</label></div>
                <input class="c-form-group__input" 
                    [ngClass]="{'disabled-div':!sessionWidgetConfig.widget.applyCatalogConfiguration}"
                    [(ngModel)]="widgetTextConfiguration.similarSessions" cclFormInput/>
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>

        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="similarSessionsButton">Similar Sessions Button</label></div>
                <input class="c-form-group__input" 
                    [ngClass]="{'disabled-div':!sessionWidgetConfig.widget.applyCatalogConfiguration}"
                    [(ngModel)]="widgetTextConfiguration.similarSessionsButton" cclFormInput/>
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>

        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="similarSessionsTitle">Similar Sessions Title</label></div>
                <input class="c-form-group__input" 
                    [ngClass]="{'disabled-div':!sessionWidgetConfig.widget.applyCatalogConfiguration}"
                    [(ngModel)]="widgetTextConfiguration.similarSessionsTitle" cclFormInput/>
                <div class="c-form-group__hint">&nbsp; Use <code>[title]</code> as placeholder for the session title.</div>
            </div>
        </div>

        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="popularSearchLabel">Popular Search Label</label></div>
                <input class="c-form-group__input" 
                    [ngClass]="{'disabled-div':!sessionWidgetConfig.widget.applyCatalogConfiguration}"
                    [(ngModel)]="widgetTextConfiguration.popularSearchLabel" cclFormInput/>
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>

        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="myScheduleAvailableSessionsTitle">Available Sessions Title</label></div>
                <input class="c-form-group__input" 
                    [ngClass]="{'disabled-div':!sessionWidgetConfig.widget.applyCatalogConfiguration}"
                    [(ngModel)]="widgetTextConfiguration.myScheduleAvailableSessionsTitle" cclFormInput/>
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
    </div>

    <!-- My Schedule section -->
    <div class="c-title--subsection config__bottom_border mb5-rem"><label>My Schedule Section</label></div>
    <div class="row">
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="myScheduleButton">My Schedule Button</label></div>
                <input class="c-form-group__input" 
                    [ngClass]="{'disabled-div':!sessionWidgetConfig.widget.applyCatalogConfiguration}"
                    [(ngModel)]="widgetTextConfiguration.myScheduleButton" cclFormInput/>
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>

        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="myScheduleTitle">My Schedule Title</label></div>
                <input class="c-form-group__input" 
                    [ngClass]="{'disabled-div':!sessionWidgetConfig.widget.applyCatalogConfiguration}"
                    [(ngModel)]="widgetTextConfiguration.myScheduleTitle" cclFormInput/>
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>

        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="myScheduleSubTitle">My Schedule Subtitle</label></div>
                <input class="c-form-group__input" 
                    [ngClass]="{'disabled-div':!sessionWidgetConfig.widget.applyCatalogConfiguration}"
                    [(ngModel)]="widgetTextConfiguration.myScheduleSubTitle" cclFormInput/>
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>

        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="myScheduleColumn">My Schedule Column</label></div>
                <input class="c-form-group__input" 
                    [ngClass]="{'disabled-div':!sessionWidgetConfig.widget.applyCatalogConfiguration}"
                    [(ngModel)]="widgetTextConfiguration.myScheduleColumn" cclFormInput/>
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>

        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="myScheduleRecommendationColumn">Recommendation Column</label></div>
                <input class="c-form-group__input" 
                    [ngClass]="{'disabled-div':!sessionWidgetConfig.widget.applyCatalogConfiguration}"
                    [(ngModel)]="widgetTextConfiguration.myScheduleRecommendationColumn" cclFormInput/>
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>

        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="myScheduleFillTheDayButton">Fill the Day Button</label></div>
                <input class="c-form-group__input" 
                    [ngClass]="{'disabled-div':!sessionWidgetConfig.widget.applyCatalogConfiguration}"
                    [(ngModel)]="widgetTextConfiguration.myScheduleFillTheDayButton" cclFormInput/>
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
    </div>
    </div>

</div>
